import React, { useEffect } from 'react';
import { css } from 'emotion';
import { Modal } from '@spotify-internal/anchor-ds';
import {
  Banner,
  ButtonPrimary,
  ButtonSecondary,
  TextLink,
} from '@spotify-internal/encore-web';
import { RetinaPicture } from 'components/RetinaPicture';
import { paths } from 'client/shared/Paths';
import { events } from './events';

function EnableRSSFeedModal({
  onClickClose,
  onClickEnable,
}: {
  onClickClose: () => void;
  onClickEnable: () => void;
}) {
  // analytics
  useEffect(() => {
    events.enableRssModalScreenViewed();
  }, []);

  return (
    <Modal
      isShowing
      isShowingCloseButton
      aria-labelledby="enable-rss-feed-modal-title"
      onClose={() => {
        events.enableRssModalExitButtonClicked();
        onClickClose();
      }}
    >
      <Modal.Image as="div">
        <RetinaPicture
          imagePath="/distribution/rss-icon"
          alt="Minimalized display of Spotify's mobile user interface"
          fallbackExtension="png"
        />
      </Modal.Image>
      <Modal.Title id="enable-rss-feed-modal-title">
        Enable your RSS feed?
      </Modal.Title>
      <Modal.Subtitle>
        Your RSS feed allows your podcast to appear in other podcast apps, in
        some cases automatically.
      </Modal.Subtitle>
      <Modal.Body>
        <Banner
          className={css`
            margin-top: 16px;
            border-radius: 8px;
          `}
        >
          This feed is public and contains your email address.{' '}
          <TextLink
            rel="ugc noopener noreferrer"
            target="_blank"
            href={paths.getHelpPage('whatIsAnRSSfeed')}
          >
            Click here
          </TextLink>{' '}
          to learn more.
        </Banner>
      </Modal.Body>
      <Modal.Footer>
        <ButtonSecondary
          onClick={() => {
            events.enableRssModalNotYetButtonClicked();
            onClickClose();
          }}
        >
          Not yet
        </ButtonSecondary>
        <ButtonPrimary
          onClick={() => {
            events.enableRssModalEnableFeedButtonClicked();
            onClickEnable();
          }}
        >
          Enable
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}

export { EnableRSSFeedModal };
